import styled from 'styled-components';
import { addAlpha } from '@algoan/deep-dive/theme';

export const ListItem = styled.li<{ isSelected?: boolean; isDisabled?: boolean }>`
  align-items: center;
  color: ${(props) =>
    props.isDisabled ? props.theme.secondary.softBlue1 : props.isSelected ? props.theme.main.deepBlue : ''};
  display: flex;
  font-size: 13px;
  height: 34px;
  list-style: none;
  margin-bottom: 10px;
  padding-left: 16px;
  padding-right: 24px;
  user-select: none;

  // target children
  div {
    font-weight: ${(props) => (props.isSelected || props.isDisabled ? '700' : 'normal')};
  }

  &:hover {
    background: ${(props) => (props.isDisabled ? '' : addAlpha(props.theme.algoanBlue, 0.05))};
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  }
`;
